import { object, string, array } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'
import { hasVisibleCharacters } from '@calendly/rich-text-editor'


export const logoName = {
  gmail: 'gmail',
  outlook: 'microsoft-outlook',
  calendly: 'calendly'
}

export const supportedFormattingForBody = [
  'bold',
  'italic',
  'underline',
  'list'
]

// TO DO: update validation schema when triggering actual validation
export const validationSchema = () => object().shape({
  body: object().test('validateBody', '', (body, { createError }) => {
    if (!body.delta && body.html && body.html.length) {
      return true
    }

    if (body.delta && hasVisibleCharacters(body)) {
      return true
    }

    return createError({
      message: I18n.t('publisher.meeting_intelligence.share.body_blank_error')
    })
  }),
  subject: object().test('validateSubject', '', (subject, { createError }) => {
    if (subject.plainText && subject.plainText.length) {
      return true
    }

    return createError({
      message: I18n.t('publisher.meeting_intelligence.share.subject_blank_error')
    })
  }),
  send_with: object().shape({
    type: string().required(I18n.t('publisher.booking_modal.required_label')),
    email: string().required(I18n.t('publisher.booking_modal.required_label'))
  }).required(I18n.t('publisher.booking_modal.required_label')),
  to_addresses: array()
    .of(
      object().shape({
        id: string().required(),
        email: string().email(I18n.t('publisher.meeting_intelligence.share.email_invalid_error')),
      })
    )
    .required('Please enter at least one valid email address')
    .test('non-empty', 'Must enter at least one email', (value, { createError }) => {
      if (value && value.some(({ email }) => email)) {
        return true
      }

      return createError({
        message: I18n.t('publisher.meeting_intelligence.share.email_missing_error')
      })
    }),
})
